/**
 * Permissions de l'utilisateur courant (docs/07 §8).
 *
 * ⚠️ **L'interface cache, elle ne protège pas.** Toute permission qui masque un
 * élément d'écran DOIT être revérifiée côté serveur, dans le cas d'usage. Ce
 * hook sert à ne pas montrer un bouton qui produirait un 403, rien de plus.
 */
import { useMemo } from "react";

import { useSessionStore } from "@/shared/auth/session";

interface Permissions {
  can: (slug: string) => boolean;
  canAny: (...slugs: string[]) => boolean;
  hasRole: (slug: string) => boolean;
  isAuthenticated: boolean;
  isEmailVerified: boolean;
}

export function usePermissions(): Permissions {
  const user = useSessionStore((state) => state.user);
  const status = useSessionStore((state) => state.status);

  return useMemo(() => {
    const granted = new Set(user?.permissions ?? []);
    const roles = new Set(user?.roles ?? []);
    return {
      can: (slug: string) => granted.has(slug),
      canAny: (...slugs: string[]) => slugs.some((slug) => granted.has(slug)),
      hasRole: (slug: string) => roles.has(slug),
      isAuthenticated: status === "authenticated",
      isEmailVerified: user?.is_email_verified ?? false,
    };
  }, [user, status]);
}
